"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("@CommonFrontendBackend/Templates/Utils");
var NavigationService = (function () {
    function NavigationService(permissionsService, projectOpener, projectCreator, getTemplate, templateState, rolesService, user, templates, updateTemplateState) {
        var _this = this;
        var template = getTemplate(templateState);
        this.getEditState = function () {
            if (template && permissionsService.isAllowed(template.$userAction, "edit")) {
                return "idle";
            }
            else {
                return "disabled";
            }
        };
        this.getCloneState = function () {
            if (template && rolesService.isAdmin(user)) {
                return "idle";
            }
            else {
                return "disabled";
            }
        };
        this.getCreateProjectState = function () {
            if (template) {
                return "idle";
            }
            else {
                return "disabled";
            }
        };
        this.getEditVisibility = function () {
            if (template) {
                return template.isAccountTemplate;
            }
            else {
                return false;
            }
        };
        this.getCloneVisibility = function () {
            if (template) {
                return template.isAccountTemplate;
            }
            else {
                return false;
            }
        };
        this.editTemplate = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, projectOpener.open({ _id: templateState.projectId })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.cloneTemplate = function () { return __awaiter(_this, void 0, Promise, function () {
            var templateProject, createdTemplate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templateProject = {
                            _id: template.projectId,
                            name: template.name,
                        };
                        return [4, projectCreator.cloneTemplate(templateProject, {
                                isAccountTemplate: template.isAccountTemplate,
                                templateState: templateState,
                                template: template,
                            })];
                    case 1:
                        createdTemplate = _a.sent();
                        templates.library.push((0, Utils_1.extractTemplateDataFromProjectForTemplateLibrary)(createdTemplate));
                        return [2, createdTemplate._id];
                }
            });
        }); };
        this.getTemplateName = function () {
            if (template) {
                return template.name;
            }
        };
        this.isAccountTemplate = function () {
            return template === null || template === void 0 ? void 0 : template.isAccountTemplate;
        };
        this.getCrmInfo = function () {
            if (template) {
                return template.crmInfo;
            }
        };
        this.isAutoExpiryEnabled = function () {
            return template === null || template === void 0 ? void 0 : template.isAutoExpiryEnabled;
        };
        this.isSecurityEnabled = function () {
            return template === null || template === void 0 ? void 0 : template.isSecurityEnabled;
        };
    }
    return NavigationService;
}());
exports.default = NavigationService;
